export default __webpack_public_path__ + "static/gambod-2966fe6be5fc2c53c9a798b683c03c15.png";